module.exports = __webpack_public_path__ + "static/img/showcase_doritos.967756c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_doritos.png
// module id = 752
// module chunks = 1